import { TranscriptionFilterOptionEnabled } from "models/ModelCompute";
import { useEffect, useState } from "react";
import OrganizationService from "../Organization.service";

type Props = {
    id: string;
};

const useTranscriptionFilterOptions = ({ id }: Props) => {
    const [transcriptionFilterOptions, setTranscriptionFilterOptions] =
        useState<TranscriptionFilterOptionEnabled[] | null>();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!id) {
            return;
        }
        let destroyed = false;
        const runFn = async () => {
            try {
                setIsLoading(true);
                const res =
                    await OrganizationService.getTranscriptionFilterOptions(id);
                if (!destroyed) {
                    setTranscriptionFilterOptions(res);
                    setIsLoading(false);
                }
            } catch (err) {
                console.error(err);
                setIsLoading(false);
            }
        };
        runFn();
        return () => {
            destroyed = true;
            setTranscriptionFilterOptions(null);
        };
    }, [id]);

    return {
        transcriptionFilterOptions,
        setTranscriptionFilterOptions,
        isLoading,
    };
};

export default useTranscriptionFilterOptions;
